import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import style from './Header.module.scss';
import logoMark from '../imgs/yesterday-stories-logo.png';
import ProfileMenu from './ProfileMenu';

const Header = ({ user, setShow, onSignOut }) => {
    const [menuOpen, setMenuOpen] = useState(false);
    const closeMenu = () => setMenuOpen(false);

    return (
        <header className={style.header}>
            <div className={`wrap ${style.nav}`}>
                <Link
                    to="/"
                    className={style.logo}
                    onClick={() => { window.scrollTo(0, 0); closeMenu(); }}
                >
                    <img src={logoMark} alt="Yesterday Stories" className={style.logoMark} />
                    Yesterday Stories
                </Link>
                <button
                    type="button"
                    className={style.menuToggle}
                    aria-label={menuOpen ? "Close menu" : "Open menu"}
                    aria-expanded={menuOpen}
                    onClick={() => setMenuOpen((prev) => !prev)}
                >
                    <span className={`${style.menuIcon} ${menuOpen ? style.menuIconOpen : ''}`} />
                </button>
                <div className={`${style.navCollapse} ${menuOpen ? style.navCollapseOpen : ''}`}>
                    <nav className={style.navLinks}>
                        <Link to="/#how-it-works" onClick={closeMenu}>How it works</Link>
                        <Link to="/#stories" onClick={closeMenu}>Stories</Link>
                        <Link to="/#trails" onClick={closeMenu}>Trails</Link>
                        <Link to="/#do" onClick={closeMenu}>Create</Link>
                        <Link to="/schools" onClick={closeMenu}>Schools</Link>
                    </nav>
                    <div className={style.navActions}>
                        {user ? (
                            <ProfileMenu onLogout={onSignOut} />
                        ) : (
                            <button
                                type="button"
                                className={style.authLink}
                                onClick={() => { setShow && setShow("flex"); closeMenu(); }}
                            >
                                Sign In / Register
                            </button>
                        )}
                        <Link to="/#about" className={style.navCta} onClick={closeMenu}>Get the app</Link>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default Header;
